var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullstack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 -0.7 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 7.33317C13.6666 11.0151 10.6818 13.9998 6.99992 13.9998C3.31802 13.9998 0.333252 11.0151 0.333252 7.33317C0.333252 3.65127 3.31802 0.666504 6.99992 0.666504C10.6818 0.666504 13.6666 3.65127 13.6666 7.33317Z",
    fill: "#1D2939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22561 8.66598L6.81576 6.2859C6.93121 6.22604 7.06856 6.22604 7.18402 6.2859L11.7742 8.66598C12.062 8.81523 12.062 9.22694 11.7742 9.37618L7.18402 11.7563C7.06856 11.8161 6.93121 11.8161 6.81576 11.7563L2.22561 9.37618C1.93778 9.22694 1.93778 8.81523 2.22561 8.66598Z",
    fill: "#A77B0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99743 7.02212L6.87724 4.49185C6.95421 4.45194 7.04577 4.45194 7.12274 4.49185L12.0025 7.02212C12.1944 7.12161 12.1944 7.39609 12.0025 7.49559L7.12274 10.0259C7.04577 10.0658 6.95421 10.0658 6.87724 10.0259L1.99743 7.49559C1.80554 7.39609 1.80554 7.12161 1.99743 7.02212Z",
    fill: "#D99D09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99743 5.2604L6.87724 2.73013C6.95421 2.69022 7.04577 2.69022 7.12274 2.73013L12.0025 5.2604C12.1944 5.35989 12.1944 5.63437 12.0025 5.73387L7.12274 8.26414C7.04577 8.30405 6.95421 8.30405 6.87724 8.26414L1.99743 5.73387C1.80554 5.63437 1.80554 5.35989 1.99743 5.2604Z",
    fill: "#F5C244"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullstack);
export default __webpack_public_path__ + "static/media/fullstack.bba20c51e0dc18fa4fac90e33dc9664c.svg";
export { ForwardRef as ReactComponent };